import { Component, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { EventSeverityDisplayComponent } from '@iot-platform/iot-platform-ui';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'grid-engine-severity-cell',
  templateUrl: './severity-cell.component.html',
  imports: [EventSeverityDisplayComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./severity-cell.component.scss']
})
export class SeverityCellComponent implements ICellRendererAngularComp {
  params: WritableSignal<ICellRendererParams> = signal(null);

  agInit(params: ICellRendererParams): void {
    this.params.set(params);
  }

  refresh(): boolean {
    return false;
  }
}
